import type { T2AImage } from '@/app/types';

export const TEXT_2_AUDIO_IMAGE: T2AImage[] = [
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_1-63c14b17.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_1-63c14b17.webp',
    },
    blurHash: 'UDNBQG3lup@%4L?A@}E71u;iRjtM$RrvEhX5',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_2-2ba18ccf.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_2-2ba18ccf.webp',
    },
    blurHash: 'U6Jj~M0E0G02000j?[00x9.75Av{nA^$9O--',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_3-153d70cb.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_3-153d70cb.webp',
    },
    blurHash: 'Uf8kjJUIWBo3b+b-WXa#teWFafj[a~a#f8f8',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_4-ff34940e.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_4-ff34940e.webp',
    },
    blurHash: 'UJQ$649lKjW,03G?O?WGY%N1NIj=v}njs.n%',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_5-6e5c6a3c.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_5-6e5c6a3c.webp',
    },
    blurHash: 'UWG^642er{xBDMq]t1S5-.IDoxoetLR,fkoe',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_6-61ab7579.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_6-61ab7579.webp',
    },
    blurHash: 'UqKCj%{l$Rbu=zawR+WV%2V@X7W;bFV[bafk',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_7-7457257b.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_7-7457257b.webp',
    },
    blurHash: 'UsN88_%jt8aw}zOlbFn,%0X2aya#W?oNR*ay',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_8-e583d388.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_8-e583d388.webp',
    },
    blurHash: 'U@Ma?=nJouS${Ka7W@oInka#f6n%OXbYj?a#',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_9-08b12fe1.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_9-08b12fe1.webp',
    },
    blurHash: 'ULAC=G~Q-$xU0l7~KjSh?X--rXV[ItNHoyt4',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_10-bfc4b81e.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_10-bfc4b81e.webp',
    },
    blurHash: 'UDBW4%{aW.bx0f5{V[o4=#$TacbIS0bHoLju',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_11-fe4432ab.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_11-fe4432ab.webp',
    },
    blurHash: 'UoBPydH^WAjbKHxFtQa{.hM}VtkBRktPahk9',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_12-c6946068.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_12-c6946068.webp',
    },
    blurHash: 'UQO2th~bN2s.4$$^t3WERnRnk7oeWFa#WEoc',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_13-a6d8e7cd.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_13-a6d8e7cd.webp',
    },
    blurHash: 'UMR9N-B?NajF*Bu4S6niI-fgOEj@nNrqR-bH',
  },
  {
    cover: {
      china: 'https://image01-aliyun.vidu.zone/vidu/media-asset/audio_cover_14-154c38d9.webp',
      global: 'https://image01.cf.vidu.studio/vidu/media-asset/audio_cover_14-154c38d9.webp',
    },
    blurHash: 'UB6D_]C-mKrr%kL.tPbaZNa6kBf,Rno|bHba',
  },
];
